import { screenExtraSmallMax, screenSmallMax, screenLarge, sliderHorizontal11Cls, sliderHorizontal41Cls, sliderHorizontal51Cls, sliderHorizontal71Cls, sliderHorizontal72Cls } from "./Slider.less";
var breakpoints = {
  small: parseInt(screenExtraSmallMax, 10),
  medium: parseInt(screenSmallMax, 10),
  large: parseInt(screenLarge, 10)
};
var SETTINGS = {
  1: {
    styles: {
      1: {
        className: sliderHorizontal11Cls,
        slidesPerRow: 1,
        infinite: false,
        responsive: [{
          breakpoint: breakpoints.large,
          settings: {
            slidesPerRow: 1,
            infinite: false
          }
        }, {
          breakpoint: breakpoints.medium,
          settings: {
            slidesPerRow: 1,
            infinite: false
          }
        }, {
          breakpoint: breakpoints.small,
          settings: {
            slidesPerRow: 1,
            centerMode: true,
            centerPadding: "30%",
            dots: false,
            arrows: false,
            infinite: true
          }
        }]
      }
    }
  },
  3: {
    styles: {
      1: {
        className: sliderHorizontal41Cls,
        slidesPerRow: 4,
        infinite: false,
        responsive: [{
          breakpoint: breakpoints.large,
          settings: {
            slidesPerRow: 3,
            infinite: false
          }
        }, {
          breakpoint: breakpoints.medium,
          settings: {
            slidesPerRow: 2,
            infinite: false
          }
        }, {
          breakpoint: breakpoints.small,
          settings: {
            slidesPerRow: 1,
            centerMode: true,
            centerPadding: "30%",
            dots: false,
            arrows: false,
            infinite: true
          }
        }]
      }
    }
  },
  4: {
    styles: {
      1: {
        className: sliderHorizontal41Cls,
        slidesPerRow: 4,
        infinite: false,
        responsive: [{
          breakpoint: breakpoints.large,
          settings: {
            slidesPerRow: 3,
            infinite: false
          }
        }, {
          breakpoint: breakpoints.medium,
          settings: {
            slidesPerRow: 2,
            infinite: false
          }
        }, {
          breakpoint: breakpoints.small,
          settings: {
            slidesPerRow: 1,
            centerMode: true,
            centerPadding: "20%",
            dots: false,
            arrows: false,
            infinite: true
          }
        }]
      }
    }
  },
  5: {
    styles: {
      1: {
        className: sliderHorizontal51Cls,
        slidesPerRow: 5,
        infinite: false,
        responsive: [{
          breakpoint: breakpoints.large,
          settings: {
            slidesPerRow: 4,
            infinite: false
          }
        }, {
          breakpoint: breakpoints.medium,
          settings: {
            slidesPerRow: 3,
            infinite: false
          }
        }, {
          breakpoint: breakpoints.small,
          settings: {
            slidesPerRow: 1,
            centerMode: true,
            centerPadding: "20%",
            dots: false,
            arrows: false,
            infinite: true
          }
        }]
      }
    }
  },
  7: {
    styles: {
      1: {
        className: sliderHorizontal71Cls,
        slidesPerRow: 7,
        infinite: false,
        responsive: [{
          breakpoint: breakpoints.large,
          settings: {
            slidesPerRow: 5,
            infinite: false
          }
        }, {
          breakpoint: breakpoints.medium,
          settings: {
            slidesPerRow: 4,
            infinite: false
          }
        }, {
          breakpoint: breakpoints.small,
          settings: {
            slidesPerRow: 1,
            centerMode: true,
            centerPadding: "20%",
            dots: false,
            arrows: false,
            infinite: true
          }
        }]
      },
      2: {
        className: "".concat(sliderHorizontal71Cls, " ").concat(sliderHorizontal72Cls),
        slidesPerRow: 7,
        infinite: false,
        dots: false,
        responsive: [{
          breakpoint: breakpoints.large,
          settings: {
            slidesPerRow: 5,
            infinite: false,
            dots: false
          }
        }, {
          breakpoint: breakpoints.medium,
          settings: {
            slidesPerRow: 4,
            infinite: false,
            dots: false
          }
        }, {
          breakpoint: breakpoints.small,
          settings: {
            slidesPerRow: 2,
            dots: false,
            arrows: false,
            infinite: false
          }
        }]
      }
    }
  }
};
export {
  SETTINGS
};
